module.exports = __webpack_public_path__ + "static/media/termopary11ru.e8662439.pdf";